module.exports = __webpack_public_path__ + "img/Stop_War_HD 2_00090.07f0ee56.png";